// TODO: move these to frontend

// just classification for now
export const GenericFineTuningPromptV2 = `
I am able to extract parameters from inputs and outputs.

Input: {{ input }}
Output: 
`.trim();
